import {AxiosRequestConfig, AxiosError} from 'axios';
import {BaseQueryFn} from '@reduxjs/toolkit/dist/query';
import {traceAxiosInstance} from './trace.axios';
import getFirebaseTokenId from './utils/getFirebaseToken';


export const traceBaseQueryFn: BaseQueryFn<
  {
    url: string;
    baseUrl?: string;
    method?: AxiosRequestConfig['method'];
    body?: AxiosRequestConfig['data'];
    params?: AxiosRequestConfig['params'];
    apiVersion?: string;
    contentType?: string;
    noAuth?: boolean;
    noSession?: boolean;
  },
  unknown,
  unknown,
  {}
> = async ({
  url,
  method,
  body: data,
  params,
  apiVersion = '2',
  contentType,
  noAuth,
  noSession
}, { signal }) => {
  try {
    const token = await getFirebaseTokenId();
    const sessionId = localStorage.getItem('sessionId');
    
    const headers: Record<string, string | undefined> = {
      Authorization: noAuth ? undefined : 'Bearer ' + token,
    };
    
    // Add session ID to headers if it exists and not explicitly disabled
    if (sessionId && !noSession) {
      headers['x-session-id'] = sessionId;
    }
    
    const result = await traceAxiosInstance({
      url,
      method,
      data,
      params,
      signal,
      headers,
    });

    return {
      data: result.data,
      error: undefined,
    };
  } catch (axiosError) {
    const err = axiosError as AxiosError;

    if (err.name === 'CanceledError' || err.message === 'canceled') {
      return {
        error: {status: 'ABORT_ERROR', data: 'Request was aborted'},
      };
    }
    // Handle 401 errors that might be related to session issues
    if (err.response?.status === 401) {
      // Session might be invalid or expired
      // We'll handle this in the SessionContext
    }
    
    return {
      error: {status: err.response?.status, data: err.response?.data},
      data: undefined,
    };
  }
};
